module.exports = __webpack_public_path__ + "img/handraw_transporteur.a0b18389.svg";